/** push通知を表示. */
export const OPEN_POPUP_NOTICE = "OPEN_POPUP_NOTICE";
/** push通知を閉じる. */
export const CLOSE_POPUP_NOTICE = "CLOSE_POPUP_NOTICE";
